module.exports = __webpack_public_path__ + "static/media/super-glacener.fbd9f2aa.jpg";